import Vue from 'vue';
import { capitalize } from '@/services/utils';
/**
 * @typedef {import('@/models/mybets/model-mybet-items').default} MyBetItemsModel
 */

/**
 * Get additional name from market name
 * @param {MyBetItemsModel} event
 */
function getAdditionalNameFromMarket(event) {
  const translatedAdditionalNames = {
    goal: Vue.prototype.$translate.text('M.goal'),
    goals: Vue.prototype.$translate.text('M.goals'),
    card: Vue.prototype.$translate.text('M.card'),
    cards: Vue.prototype.$translate.text('M.cards'),
    corner: Vue.prototype.$translate.text('M.corner'),
    corners: Vue.prototype.$translate.text('M.corners'),
    // tries: Vue.prototype.$translate.text('tries'),
    // sets: Vue.prototype.$translate.text('sets'),
  };
  let addItionalText = '';
  let kindOfNum = event.originalMarketName.match(/\b(goals?|cards?|corners?)\b/i);
  if (kindOfNum) {
    const pluralCheck = +event.outcomeName.trim();
    let key = kindOfNum[0].replace('s', '').toLowerCase();
    if (!pluralCheck || pluralCheck > 1) {
      key += 's';
    }
    addItionalText = ` ${translatedAdditionalNames[key]}`;
  }

  return addItionalText;
}
function checkIfOutcomeIsNumber(event) {
  return event.originalMarketName.match(/(total|exact|number|many|goals?)/i)
    && !event.originalMarketName.match(/\b(matchbet|next|asians?|who|which|spreads?|handicap)\b/i);
}
/**
 * Convert outcome to latam specific name
 * @param {MyBetItemsModel} event
 */
export function getLatamOutcomeName(event) {
  if (!event.matchTitle || !event.originalOutcomeName) {
    return event.outcomeName;
  }

  const teams = event.matchTitle.split('vs');
  const overUnderNum = event.specialBetValue;
  const draw = Vue.prototype.$translate.text('Outcome.Draw');
  const yes = capitalize(Vue.prototype.$translate.text('W.M.Y').toLowerCase());
  const no = capitalize(Vue.prototype.$translate.text('W.M.N').toLowerCase());
  const odd = Vue.prototype.$translate.text('W.M.Odd');
  const even = Vue.prototype.$translate.text('W.M.Even');
  const fgin = Vue.prototype.$translate.text('M.FirstGoalIn');
  const ngin = Vue.prototype.$translate.text('M.NextGoalIn');
  const over = Vue.prototype.$translate.text('W.M.O');
  const under = Vue.prototype.$translate.text('W.M.U');
  const teamScore = Vue.prototype.$translate.text('M.TeamScore');
  let home = teams[0].trim();
  const addedText = getAdditionalNameFromMarket(event);
  const oddEvenAddedText = addedText;
  const marketHasNumber = event.originalMarketName.match(/\s+\d+\s+/);
  const isAsian = event.specialBetValue;
  const none = addedText ? `${no} ${addedText}` : `${no} ${teamScore}`;
  const firstGoalIn = marketHasNumber ? `${fgin} $1'` : '$1';
  let away = '';
  let handicap = overUnderNum || '';
  if (overUnderNum && event.originalMarketName.match(/\b(handicaps?|asians?)\b/i)) {
    handicap = overUnderNum.replace(':0', '+').replace('0:', '-');
  }
  let asians = '';
  if (isAsian) {
    asians = ` (${handicap})`;
  }
  if (teams.length > 1) {
    away = teams[1].split('(')[0].trim();
  }
  let asiansDraw = '';
  if (isAsian && event.originalMarketName.match(/\b(handicaps?|asians?)\b/i)) {
    const hcap = overUnderNum.replace(/(\d+):0/, `${home} -$1`).replace(/0:(\d+)/, `${away} -$1`);
    asiansDraw = ` (${hcap})`;
  }
  // special case for number in outcomes
  if (checkIfOutcomeIsNumber(event)) {
    home = event.outcomeName.trim() + addedText;
    away = event.outcomeName.trim() + addedText;
  }
  let trimmed = event.originalOutcomeName.trim();
  let regexes = [
    { reg: /^(home|1)$/i, val: `${home}${asians}` },
    { reg: /^(x|draw)$/i, val: `${draw}${asiansDraw}` },
    { reg: /^(away|2)$/i, val: `${away}${asians}` },
    { reg: /^(under|over)$/i, val: `z$1z ${overUnderNum}`, chg: true },
    { reg: /^yes$/i, val: yes },
    { reg: /^no$/i, val: no },
    { reg: /^1x$/i, val: `${home}/${draw}` },
    { reg: /^12$/, val: `${home}/${away}` },
    { reg: /^x2$/i, val: `${away}/${draw}` },
    { reg: /^odd$/i, val: `${odd}${oddEvenAddedText}` },
    { reg: /^even$/i, val: `${even}${oddEvenAddedText}` },
    { reg: /^none$/i, val: none },
    // MATCHBET
    { reg: /^(home|away|draw)\s?and\s?(home|away|draw)$/i, val: 'z$1z/z$2z', chg: true },
    { reg: /^(home|away|draw)\s?(\/|and)\s?(yes|no)$/i, val: 'z$1z/z$3z', chg: true },
    { reg: /^(home|away|draw)\s?and\s?(over|under)\s?$/i, val: `z$1z/z$2z ${overUnderNum}`, chg: true },
    { reg: /^(over|under)\s?and\s?(home|away|draw)\s?$/i, val: `z$2z/z$1z ${overUnderNum}`, chg: true },
    { reg: /^(yes|no)\s?\/\s?(over|under)\s?$/i, val: `z$1z/z$2z ${overUnderNum}`, chg: true },
    { reg: /^(\d+-\d+){1}$/, val: `${firstGoalIn}` },
    { reg: /^min\s?(\d+-\d+){1}$/i, val: `${ngin} $1'` },
    { reg: /^\d+\+?$/, val: home },
  ];
  let ns = '';
  let additionalReplace = false;
  const changed = regexes.some((r) => {
    ns = trimmed.replace(r.reg, r.val);
    if (ns !== trimmed) {
      additionalReplace = r.chg;
      return true;
    }
    return false;
  });
  if (changed && additionalReplace) {
    ns = ns.replace(/zoverz/i, over).replace(/zunderz/i, under);
    ns = ns.replace(/zhomez/ig, home).replace(/zawayz/ig, away).replace(/zdrawz/ig, draw);
    ns = ns.replace(/zyesz/ig, yes).replace(/znoz/ig, no);
  }
  return changed ? ns : event.outcomeName;
}
